import { combineReducers } from 'redux';
import { createBrowserHistory } from 'history';
import {
  configureStore,
  getDefaultMiddleware,
  StoreEnhancer,
  SerializableStateInvariantMiddlewareOptions,
} from '@reduxjs/toolkit';
import { dialogReducer } from 'stores/dialogSlice';
import { deviceReducer } from 'stores/deviceSlice';
import { errorReducer } from 'stores/errorSlice';
import { createSentryReduxEnhancer } from 'stores/enhancer';

export const history = createBrowserHistory();

const reducer = combineReducers({
  dialogState: dialogReducer,
  deviceState: deviceReducer,
  errorState: errorReducer,
});

const enhancers: StoreEnhancer[] = [createSentryReduxEnhancer()];

export const store = configureStore({
  reducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['dialog/showDialog', 'error/setExceptionError'],
      } as SerializableStateInvariantMiddlewareOptions,
    }),
  ] as const,
  enhancers,
  devTools: process.env.NODE_ENV !== 'production',
});
